<template>
  <applyModal :modalTitle="'信息变更申请'" :isDetailStatus="false" :modal-width="'1000px'" ref="modalDetailRef">
    <div class="mt20 mb62 container-layout">
      <!-- 左侧菜单栏 -->
      <div class="left-menu">
        <div class="menu-item" :class="{ 'active': currentTab === 'basicInfo' }" @click="switchTab('basicInfo')">
          基本信息变更
        </div>
        <div class="menu-item" :class="{ 'active': currentTab === 'testPlate' }" @click="switchTab('testPlate')">
          测试牌照变更
        </div>
      </div>

      <!-- 右侧内容区域 -->
      <div class="right-content">
        <!-- 动态加载组件 -->
        <component
            :is="currentComponent"
            :carInfo="carInfo"
            :changeInfo="changeInfo"
            @basic-change="handleBasicChange"
            @plate-change="handlePlateChange"
            @withdraw-change="handleWithdrawChange"
            :onCancel="cancel"
        ></component>
      </div>
    </div>
  </applyModal>
</template>

<script setup>
import { ref, defineProps, defineEmits, defineExpose, computed, watch } from 'vue';
import applyModal from '@/components/modal/index.vue';
// 引入新创建的组件
import BasicInfoChange from './basicInfoChange.vue';
import TestPlateChange from './testPlateChange.vue';
import { detailById, checkByCarId, addCarChangeApply, withdrawCarChangeApply } from "@/api/car/car";
import { message } from "ant-design-vue";

const props = defineProps({
  carId: {
    type: String
  }
});

const carInfo= ref({})
const changeInfo= ref({})

const emits = defineEmits(["closeBox"]);

// 标签切换相关
const currentTab = ref('basicInfo'); // 默认显示基本信息
const switchTab = (tab) => {
  currentTab.value = tab;
};

// 动态组件计算属性
const currentComponent = computed(() => {
  return currentTab.value === 'basicInfo' ? BasicInfoChange : TestPlateChange;
});

const modalDetailRef = ref();

const show = (record) => {
  modalDetailRef.value.showModal();
};

// 处理子组件事件
const handleBasicChange = (fileUrl) => {
  let obj = {
    carId: props.carId,
    "type": 1,//基础信息变更
    "createBy": 0,
    "fileUrl": fileUrl
  }
  addCarChangeApply(obj).then(res => {
    if (res.code === 200) {
      message.success('申请成功');
      //emits('closeBox');
      getChangeRecords();
    }
  })
};

const handlePlateChange = (data) => {

  let afterData = {
    "testCarNum": data.testCarNum,
    "plateApplyDateStr": data.plateApplyDateStr,
    "plateExpireDateStr": data.plateExpireDateStr,
    "plateAttachmentUrl": data.plateAttachmentUrl
  }
  let obj = {
    carId: props.carId,
    "type": 2,//测试牌照信息变更
    "afterData": afterData
  }
  addCarChangeApply(obj).then(res => {
    if (res.code === 200) {
      message.success('申请成功');
      //emits('closeBox');
      getChangeRecords();
    }
  })
};

const handleWithdrawChange = (data) => {

  let obj = {
    "id": data.id,
  }
  withdrawCarChangeApply(obj).then(res => {
    if (res.code === 200) {
      message.success('撤销成功');
      //emits('closeBox');
      getChangeRecords();
    }
  })
}

//查询车辆信息
const getCarInfo = () => {
  if (props.carId) { // 确保carId存在
    detailById({ id: props.carId}).then(res => {
      if (res.code === 200) {
        carInfo.value = res.data;
      }
    })
  }
}

//查询变更记录数
const getChangeRecords = () => {
  if (props.carId) { // 确保carId存在
    checkByCarId({ id: props.carId }).then(res => {
      if (res.code === 200) {
        changeInfo.value = res.data;
      }
    })
  }
}

//添加对carId的监听事件
watch(
    () => props.carId,
    (newValue) => {
      if (newValue) {
        getCarInfo();
        getChangeRecords();
      }
    },
    { deep: true, immediate: true }
)

// 取消
const cancel = () => {
  modalDetailRef.value.hideModal();
};

defineExpose({
  show,
  cancel
});
</script>

<style lang="less" scoped>
.mb62 {
  margin-bottom: 62px;
}

.container-layout {
  display: flex;
  width: 100%;
  max-width: 950px;
}

.left-menu {
  width: 140px;
  background: #F6F8FA;
  border-radius: 4px;
  padding: 10px 0;
  margin-right: 20px;
  min-height: 500px;
}

.menu-item {
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  color: #636D7B;

  &:hover {
    background: #E8EBF0;
  }

  &.active {
    background: #E8EBF0;
    color: #186FF2;
    font-weight: 500;
  }
}

.right-content {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: calc(100% - 200px);
  min-width: 0;
}
</style>